import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AlertService } from 'src/app/core/alert.service';
import { LoadingService } from 'src/app/core/loading.service';
import { UtilityService } from 'src/app/core/utility.service';
import { ProfileService } from 'src/app/inside-layout/routes/profile/profile.service';
import { Constants } from '../../app.constants';
import { AuthService } from '../../core/auth.service';
import { HttpRequestType, RequestService } from '../../core/request.service';
import { BaseService } from '../base/base.service';
import { ListReport, ReportOutputType, ReportOutputTypes } from './reports.models';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends BaseService {

  constructor(
    protected requestService: RequestService,
    private authService: AuthService,
    private http: HttpClient,
    private loadingService: LoadingService,
    private alertService: AlertService,
    private utilityService: UtilityService,
    private profileService: ProfileService
  ) {
    super(requestService);
  }

  public printListReport(url: string, reportCode: string, reportOutputType: string = ReportOutputTypes.PDF.type, parameters: string[] = [], filter: string, sort: string) {
    this.getListForReport(url, reportCode, filter, sort, (response) => {
      let documentList = response;

      documentList.forEach(document => {
        if (document.images != null && document.images.length > 0)
          document.image = this.utilityService.extractMainImage(document.images);

        if (document.product != null && document.product.images != null && document.product.images.length > 0)
          document.product.image = this.utilityService.extractMainImage(document.product.images);
      });


      let body: ListReport = {
        locale: 'bs-BA', // TODO: Mozda dodati druge jezike nekad?
        localeString: 'sr_BA',
        reportCode: reportCode == 'CTLGS' && reportOutputType == ReportOutputTypes.XLS.type ? `${reportCode}XLS` : reportCode,
        reportOutputType: reportOutputType,
        parameters: parameters,
        reportData: {
          document_list: documentList,
          logo: this.profileService.logo ? this.profileService.logo : ''
        }
      };

      this.authService.refreshTokenIfNeeded()
        .pipe(finalize(() => {
          const httpHeaders = new HttpHeaders({
            Authorization: this.authService.authHeaders.get('Authorization'),
            Accept: 'text/plain, */*, application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache'
          });

          this.loadingService.showLoader();
          this.http
            .post(
              `${Constants.reportingPath}/generate`,
              body,
              { responseType: 'blob', headers: httpHeaders }
            )
            .pipe(finalize(() => setTimeout(() => this.loadingService.hideLoader())))
            .subscribe(
              (response: Blob) => {
                const a = document.createElement('a')
                const objectUrl = URL.createObjectURL(response)
                a.href = objectUrl

                switch (reportOutputType) {
                  case ReportOutputTypes.PDF.type:
                  case ReportOutputTypes.JSON.type:
                  case ReportOutputTypes.XML.type:
                  case ReportOutputTypes.HTML.type:
                    window.open(URL.createObjectURL(response));
                    break;
                  default:
                    a.download = `${reportCode}.${reportOutputType.toLowerCase()}`;
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                    break;
                }
              },
              (error: any) => {
                this.loadingService.hideLoader()
                let ePromise: Promise<string> = error.error.text();
                ePromise.then(text => this.alertService.error(JSON.parse(text).error_description));
              }
            );
        }))
        .subscribe();


    }, (error) => {
      this.alertService.error(error, true);
    });
  }

  public printSingleReport(reportCode: string, reportOutputType: string = ReportOutputTypes.PDF.type, documentForPrint: any) {
    let body: ListReport = {
      locale: 'bs-BA', // TODO: Mozda dodati druge jezike nekad?
      localeString: 'sr_BA',
      reportCode: reportOutputType != ReportOutputTypes.PDF.type ? `${reportCode}${reportOutputType}` : reportCode,
      reportOutputType: reportOutputType,
      reportData: documentForPrint
    };

    delete body.parameters;

    this.authService.refreshTokenIfNeeded()
      .pipe(finalize(() => {
        const httpHeaders = new HttpHeaders({
          Authorization: this.authService.authHeaders.get('Authorization'),
          Accept: 'text/plain, */*, application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        });

        this.loadingService.showLoader();
        this.http
          .post(
            `${Constants.reportingPath}/generate`,
            body,
            { responseType: 'blob', headers: httpHeaders }
          )
          .pipe(finalize(() => setTimeout(() => this.loadingService.hideLoader())))
          .subscribe(
            (response: Blob) => {
              const a = document.createElement('a')
              const objectUrl = URL.createObjectURL(response)
              a.href = objectUrl

              switch (reportOutputType) {
                case ReportOutputTypes.PDF.type:
                case ReportOutputTypes.JSON.type:
                case ReportOutputTypes.XML.type:
                case ReportOutputTypes.HTML.type:
                  window.open(URL.createObjectURL(response));
                  break;
                default:
                  a.download = `${reportCode}.${reportOutputType.toLowerCase()}`;
                  a.click();
                  URL.revokeObjectURL(objectUrl);
                  break;
              }
            },
            (error: any) => {
              this.loadingService.hideLoader()
              let ePromise: Promise<string> = error.error.text();
              ePromise.then(text => this.alertService.error(JSON.parse(text).error_description));
            }
          );
      }))
      .subscribe();
  }

  public printCustomReport(url: string, reportCode: string, reportOutputType: string = ReportOutputTypes.PDF.type, filter: string, sort: string) {
    this.authService.refreshTokenIfNeeded()
    .pipe(finalize(() => {
      const httpHeaders = new HttpHeaders({
        Authorization: this.authService.authHeaders.get('Authorization'),
        Accept: 'text/plain, */*, application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      });

      if((reportCode.includes('PRDCT') || reportCode.includes('OFFRD')) && sort.includes('.'))
        sort = null;
      this.loadingService.showLoader();
      this.http
        .post(
          `${url}/report?reportType=${reportOutputType}${filter || ''}${sort || ''}`,
          null,
          { responseType: 'blob', headers: httpHeaders }
        )
        .pipe(finalize(() => setTimeout(() => this.loadingService.hideLoader())))
        .subscribe(
          (response: Blob) => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(response)
            a.href = objectUrl

            switch (reportOutputType) {
              case ReportOutputTypes.PDF.type:
              case ReportOutputTypes.JSON.type:
              case ReportOutputTypes.XML.type:
              case ReportOutputTypes.HTML.type:
                window.open(URL.createObjectURL(response));
                break;
              default:
                a.download = `${reportCode}.${reportOutputType.toLowerCase()}`;
                a.click();
                URL.revokeObjectURL(objectUrl);
                break;
            }
          },
          (error: any) => {
            this.loadingService.hideLoader()
            let ePromise: Promise<string> = error.error.text();
            ePromise.then(text => this.alertService.error(JSON.parse(text).error_description));
          }
        );
    }))
    .subscribe();
  }
}
